/* eslint-disable react/jsx-pascal-case */
import React, { useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { moleculeLog } from 'utils/logUtil'
import A_FieldCheckBox from '../A_FieldCheckBox'

type Props = {
  label: string
  check1: boolean
  check2: boolean
  check3: boolean
  check4: boolean
  event1: (e: React.ChangeEvent<HTMLInputElement>) => void
  event2: (e: React.ChangeEvent<HTMLInputElement>) => void
  event3: (e: React.ChangeEvent<HTMLInputElement>) => void
  event4: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
}

const useStyles = makeStyles(() =>
  createStyles({
    item: {
      border: '1px solid #000000',
      marginRight: 10,
      padding: 2,
    },
    noBorderItem: {
      marginRight: 10,
      padding: 2,
    },
  }),
)

const M_FieldJuryo = ({ label, check1, check2, check3, check4, event1, event2, event3, event4, disabled = false }: Props) => {
  useEffect(() => moleculeLog('M_FieldJuryo'))
  const classes = useStyles()
  return (
    <Grid container justifyContent="flex-start">
      <Grid item xs={12} sm={1}>
        <Typography variant="body1" display="block" gutterBottom>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={1} className={classes.item}>
        <A_FieldCheckBox label="未受領" check={check1} change={event1} disabled={disabled} position="end" />
      </Grid>
      <Grid item xs={12} sm={4} className={classes.item}>
        <div>
          <A_FieldCheckBox label="受領済" check={check2} change={event2} disabled={disabled} position="end" />
          <br />
          <A_FieldCheckBox label="内容確認依頼" alertLabel=" ※納品内容に問題があった場合" check={check3} change={event3} disabled={disabled} position="end" />
        </div>
      </Grid>
      <Grid item xs={12} sm={1} className={classes.noBorderItem}>
        <div>
          <A_FieldCheckBox label="欠品" check={check4} change={event4} disabled={disabled} position="end" color={'secondary'} />
        </div>
      </Grid>
    </Grid>
  )
}

export default React.memo(M_FieldJuryo)
